/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EnergiaSolarBlog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function EnergiaSolarBlog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="energia-solar-blog">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="energia-solar-blog-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`energia-solar-blog-slide ${className}`}>
                    <a
                      href="blog/economize-na-conta-de-luz-com-energia-solar.html"
                      target="_blank"
                      className="energia-solar-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-20/capa.webp" />
                        <source type="image/jpeg" srcSet="static/amp/blog/post-20/capa.jpeg" />
                        <img
                          src="static/amp/blog/post-20/capa.jpeg"
                          alt="lâmpada com filetes amarelos em cima de uma placa de energia solar"
                        />
                      </picture>
                      <div className="energia-solar-blog-card-textos">
                        <h3 className="energia-solar-blog-slide-titulo">
                          Economize na sua conta de luz com energia solar fotovoltaica
                        </h3>
                        <p className="energia-solar-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`energia-solar-blog-slide ${className}`}>
                    <a
                      href="blog/sua-casa-sustentavel-com-energia-solar.html"
                      target="_blank"
                      className="energia-solar-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-48/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-48/capa.png" />
                        <img
                          src="static/amp/blog/post-48/capa.png"
                          alt="Homem com tablet verificando gerador de energia solar com placa solar de energia ao fundo"
                        />
                      </picture>
                      <div className="energia-solar-blog-card-textos">
                        <h3 className="energia-solar-blog-slide-titulo">
                          Sua casa mais sustentável, seu bolso mais feliz com a energia solar!
                        </h3>
                        <p className="energia-solar-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`energia-solar-blog-slide ${className}`}>
                    <a
                      href="blog/energia-solar-mesmo-a-noite.html"
                      target="_blank"
                      className="energia-solar-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-62/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-62/capa.png" />
                        <img
                          src="static/amp/blog/post-62/capa.png"
                          alt="Telhado de casa com painéis solares instalados com divisão mostrando as placas de dia e a noite."
                        />
                      </picture>
                      <div className="energia-solar-blog-card-textos">
                        <h3 className="energia-solar-blog-slide-titulo">
                          Financiamento de energia solar: como funciona a geração de energia à
                          noite?
                        </h3>
                        <p className="energia-solar-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="energia-solar-blog-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/economize-na-conta-de-luz-com-energia-solar.html"
                target="_blank"
                className="energia-solar-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-20/capa.webp" />
                  <source type="image/jpeg" srcSet="static/amp/blog/post-20/capa.jpeg" />
                  <img
                    src="static/amp/blog/post-20/capa.jpeg"
                    alt="lâmpada com filetes amarelos em cima de uma placa de energia solar"
                  />
                </picture>
                <div className="energia-solar-blog-card-textos">
                  <h3 className="energia-solar-blog-slide-titulo">
                    Economize na sua conta de luz com energia solar fotovoltaica
                  </h3>
                  <p className="energia-solar-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/sua-casa-sustentavel-com-energia-solar.html"
                target="_blank"
                className="energia-solar-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-48/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-48/capa.png" />
                  <img
                    src="static/amp/blog/post-48/capa.png"
                    alt="Homem com tablet verificando gerador de energia solar com placa solar de energia ao fundo"
                  />
                </picture>
                <div className="energia-solar-blog-card-textos">
                  <h3 className="energia-solar-blog-slide-titulo">
                    Sua casa mais sustentável, seu bolso mais feliz com a energia solar!
                  </h3>
                  <p className="energia-solar-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/energia-solar-mesmo-a-noite.html"
                target="_blank"
                className="energia-solar-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-62/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-62/capa.png" />
                  <img
                    src="static/amp/blog/post-62/capa.png"
                    alt="Telhado de casa com painéis solares instalados com divisão mostrando as placas de dia e a noite."
                  />
                </picture>
                <div className="energia-solar-blog-card-textos">
                  <h3 className="energia-solar-blog-slide-titulo">
                    Financiamento de energia solar: como funciona a geração de energia à noite?
                  </h3>
                  <p className="energia-solar-blog-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarBlog;
